<template>
  <div class="d-flex align-center" style="max-width: 220px">
    <v-text-field
      v-model="selectedMonth"
      type="month"
      density="compact"
      variant="outlined"
      hide-details
      base-color="white"
      theme="dark"
      style="min-width: 140px"
      @update:model-value="onMonthChange"
    >
      <template v-slot:append-inner>
        <v-icon
          :icon="currentPeriodStatus?.is_closed ? 'mdi-lock' : 'mdi-lock-open'"
          :color="currentPeriodStatus?.is_closed ? 'error' : 'success'"
          size="small"
        />
        <v-tooltip activator="parent" location="bottom">
          {{ currentPeriodStatus?.is_closed ? "Period Closed" : "Period Open" }}
        </v-tooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script setup>
import { useWarehouse } from "@/composables/useWarehouse.js";

const { selectedMonth, currentPeriodStatus, onMonthChange } = useWarehouse();
</script>
